/**
 * Utilitários genéricos para planilhas Univer.
 * Importe onde precisar — independente de qualquer definição de tabela.
 */

/**
 * Converte um JS Date para serial numérico do Excel/Univer.
 * Excel conta dias a partir de 30/12/1899 (inclui o bug histórico de 1900).
 * Retorna null se a data for inválida.
 */
export const dateToExcelSerial = (date) => {
  if (!date) return null;

  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return null;

  const excelEpoch = new Date(Date.UTC(1899, 11, 30)); // 30 dez 1899
  return Math.floor(
    (d.getTime() - excelEpoch.getTime()) / (1000 * 60 * 60 * 24),
  );
};

/**
 * CellValueType do Univer (sem precisar importar @univerjs/core inteiro).
 * 1 = STRING, 2 = NUMBER, 3 = BOOLEAN, 4 = FORCE_TEXT
 */
export const CellType = {
  STRING: 1,
  NUMBER: 2,
  BOOLEAN: 3,
  FORCE_TEXT: 4,
};

/**
 * Converte referência estilo Excel ("A1", "H1", "AB23") em {row, col} zero-indexed.
 */
export const cellRefToRowCol = (ref) => {
  const match = /^([A-Za-z]+)(\d+)$/.exec(String(ref).trim());
  if (!match) {
    throw new Error(
      `Referência de célula inválida: "${ref}". Use o formato "A1", "B5", etc.`,
    );
  }
  const [, colLetters, rowNumber] = match;
  let col = 0;
  for (let i = 0; i < colLetters.length; i++) {
    col = col * 26 + (colLetters.toUpperCase().charCodeAt(i) - 64);
  }
  return { row: parseInt(rowNumber, 10) - 1, col: col - 1 };
};

/**
 * Inverso: {row, col} zero-indexed -> "A1"
 */
export const rowColToCellRef = (row, col) => {
  let colStr = "";
  let c = col + 1;
  while (c > 0) {
    const rem = (c - 1) % 26;
    colStr = String.fromCharCode(65 + rem) + colStr;
    c = Math.floor((c - 1) / 26);
  }
  return `${colStr}${row + 1}`;
};
